import { findParams } from 'core/utils';

class BaseService {
	apiClient = null;
	routeService = null;

	constructor(apiClient, routeService) {
		this.apiClient = apiClient;
		this.routeService = routeService;
	}

	find(filter) {
		const url = this.routeService.find(filter);
		return this.apiClient.get(url);
	}

	get(id, options = {}) {
		const url = this.routeService.get(id, options);
		return this.apiClient.get(url);
	}

	create(resource, sourceOfChange) {
		const url = this.routeService.create(sourceOfChange);
		return this.apiClient.post(url, resource);
	}

	update(resource, sourceOfChange) {
		const url = this.routeService.update(resource, sourceOfChange);
		return this.apiClient.put(url, resource);
	}

	delete(resource) {
		const url = this.routeService.delete(resource);
		return this.apiClient.delete(url);
	}

	exportToCsv(filter) {
		const url = this.routeService.exportToCsv(filter);
		return this.apiClient.post(url, findParams(filter));
	}
}

export default BaseService;
